(() => {
  const widget = document.querySelector('#stamped-main-widget[data-mdv-reviews-layout="compact"]');
  if (!widget) return;
  window.mdvReviewsCompactCleanup?.();
  const controller = new AbortController();
  const { signal } = controller;
  let control;
  let signature = '';

  function syncReviewLabels() {
    const caption = widget.querySelector('.stamped-summary-text[data-count]');
    if (caption && /^(?:Based on\s+)?[\d,\s]+\s+reviews?$/i.test(caption.textContent.trim())) {
      const count = Number(caption.dataset.count);
      if (/^\d+$/.test(caption.dataset.count) && Number.isSafeInteger(count)) {
        const text = `${count.toLocaleString('en-GB')} ${count === 1 ? 'review' : 'reviews'}`;
        if (caption.textContent !== text) caption.textContent = text;
      }
    }
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    widget.querySelectorAll('.stamped-review-header .created').forEach(element => {
      const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(element.textContent.trim());
      if (!match) return;
      const [, month, day, year] = match.map(Number);
      const date = new Date(Date.UTC(year, month - 1, day));
      if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return;
      element.textContent = `${day} ${months[month - 1]} ${year}`;
    });
  }

  function sync() {
    syncReviewLabels();
    const select = widget.querySelector('#stamped-sort-select');
    if (!select) return;
    if (!control || control.select !== select || !control.details.isConnected) {
      control?.details.remove();
      const details = document.createElement('details');
      details.className = 'mdv-review-sort';
      const trigger = document.createElement('summary');
      trigger.setAttribute('aria-haspopup', 'menu');
      const menu = document.createElement('div');
      menu.className = 'mdv-review-sort-options';
      menu.setAttribute('role', 'menu');
      menu.setAttribute('aria-label', select.getAttribute('aria-label') || 'Sort reviews');
      details.append(trigger, menu);
      select.after(details);
      select.classList.add('mdv-review-sort-native');
      control = { select, details, trigger, menu };
      signature = '';
      let openingFocus;
      trigger.addEventListener('click', event => {
        if (select.disabled) event.preventDefault();
      }, { signal });
      details.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(details.open));
        if (details.open) {
          (openingFocus || menu.querySelector('[aria-checked="true"]:not(:disabled)') || menu.querySelector('button:not(:disabled)'))?.focus();
          openingFocus = null;
        }
      }, { signal });
      menu.addEventListener('click', event => {
        const option = event.target.closest('button[data-value]');
        if (!option || option.disabled) return;
        const changed = select.value !== option.dataset.value;
        select.value = option.dataset.value;
        details.open = false;
        sync();
        trigger.focus();
        if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal });
      details.addEventListener('keydown', event => {
        if (select.disabled) {
          if (['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) event.preventDefault();
          return;
        }
        if (event.key === 'Escape') {
          details.open = false;
          trigger.focus();
          event.preventDefault();
          return;
        }
        const options = [...menu.querySelectorAll('button:not(:disabled)')];
        if (!options.length || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (!details.open) {
          openingFocus = event.key === 'Home' ? options[0] : event.key === 'End' ? options.at(-1) : null;
          details.open = true;
          return;
        }
        const index = options.indexOf(document.activeElement);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 :
          (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options[next].focus();
      }, { signal });
      details.addEventListener('focusout', event => {
        if (!details.contains(event.relatedTarget)) details.open = false;
      }, { signal });
    }
    const options = [...select.options];
    const nextSignature = JSON.stringify([select.value, select.disabled, options.map(option => [option.value, option.text, option.disabled])]);
    if (nextSignature === signature) return;
    signature = nextSignature;
    control.trigger.textContent = select.selectedOptions[0]?.text || '';
    control.trigger.setAttribute('aria-label', `${select.getAttribute('aria-label') || 'Sort reviews'}: ${control.trigger.textContent}`);
    control.trigger.setAttribute('aria-expanded', String(control.details.open));
    control.trigger.setAttribute('aria-disabled', String(select.disabled));
    control.details.classList.toggle('is-disabled', select.disabled);
    control.menu.replaceChildren(...options.map(option => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.value = option.value;
      button.textContent = option.text;
      button.setAttribute('role', 'menuitemradio');
      button.setAttribute('aria-checked', String(option.selected));
      button.tabIndex = -1;
      button.disabled = option.disabled || select.disabled;
      return button;
    }));
  }

  const observer = new MutationObserver(sync);
  observer.observe(widget, { childList: true, subtree: true });
  widget.addEventListener('change', sync, { signal });
  document.addEventListener('stamped:reviews:loaded', sync, { signal });
  document.addEventListener('click', event => {
    if (control && !control.details.contains(event.target)) control.details.open = false;
  }, { signal });
  window.mdvReviewsCompactCleanup = () => {
    observer.disconnect();
    controller.abort();
    control?.select.classList.remove('mdv-review-sort-native');
    control?.details.remove();
  };
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(widget)) window.mdvReviewsCompactCleanup();
  }, { signal });
  sync();
})();
